/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */
import {
  Layout,
  RankedTester,
  rankWith,
  RendererProps,
  UISchemaElement,
  uiTypeIs,
} from "@jsonforms/core";
import {
  JsonFormsDispatch,
  useJsonForms,
  withJsonFormsLayoutProps,
} from "@jsonforms/react";
import React from "react";
import { useSelector } from "react-redux";
import { get } from "lodash";

// Utils
import { evaluateContextRule, extractPath } from "../utils/commonUtils";

import styles from "./css/ButtonGroupRenderer.module.scss";

export const buttonGroupRendererRendererTester: RankedTester = rankWith(
  4,
  uiTypeIs("ButtonGroup")
);

function ButtonGroupRenderer({ uischema, visible }: RendererProps) {
  const { renderers, cells } = useJsonForms();

  const buttons = uischema as Layout;
  const optionsSchema = uischema as UISchemaElement;
  const style = optionsSchema?.options?.style;
  const spectrumProps = optionsSchema?.options?.spectrumProps;

  // Determine if the component should be visible
  let componentVisibility = visible;

  // If there is a context rule, evaluate it and use that visibility rule instead.
  if (uischema.options?.contextRule) {
    const scope = extractPath(uischema.options?.contextRule?.condition?.scope);
    const reduxState = useSelector((state: any) =>
      get(state?.reduxState, scope)
    );
    componentVisibility = evaluateContextRule(
      uischema.options?.contextRule,
      reduxState
    )?.visible;
  }

  return (
    <div
      {...spectrumProps}
      style={style}
      className={[
        styles.buttonGroup,
        !componentVisibility && styles.hideDiv,
      ].join(" ")}
      hidden={!componentVisibility}
    >
      {buttons?.elements.map((element: UISchemaElement, index) => (
        <JsonFormsDispatch
          key={index}
          renderers={renderers}
          cells={cells}
          uischema={element}
          schema={{}}
        />
      ))}
    </div>
  );
}

export default withJsonFormsLayoutProps(ButtonGroupRenderer);
